export default {
  my_to_dos: "My To-Dos",
  title: "To-Do",
  unsubmitted_work: "Unsubmitted Work",
  untitled_work: "Untitled Work",
}
